module.exports = __webpack_public_path__ + "static/media/element-above-video.30200abd.svg";